import PropTypes from "prop-types";

const ModalWindow = ({id, onSubmit, onClose, title, submitButtonMsg, closeButtonMsg, element}) =>{
    return (
        <div className="modal fade" id={id} data-bs-backdrop="static" tabIndex="-1" aria-labelledby={id} aria-hidden="true">
            <div className="modal-dialog">
                <form onSubmit={onSubmit}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id={id}>{title}</h5>
                            <button type="button" className="btn-close" onClick={onClose} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {element}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose} data-bs-dismiss="modal">{closeButtonMsg}</button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">{submitButtonMsg}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
ModalWindow.defaultProps = {
    closeButtonMsg: 'Close',
    submitButtonMsg: 'Save',
    onSubmit: (e) => {e.preventDefault()},
    onClose: (e) => {e.preventDefault()}
}

ModalWindow.propTypes = {
    id: PropTypes.string.isRequired
}

export default ModalWindow;